import { render, staticRenderFns } from "./RestartDialog.vue?vue&type=template&id=53fcba6d&scoped=true&"
import script from "./RestartDialog.vue?vue&type=script&lang=js&"
export * from "./RestartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fcba6d",
  null
  
)

export default component.exports